import {useMutation} from "@tanstack/react-query";
import {useNavigate, useSearchParams} from "react-router-dom";

import {TOAST_CONFIG} from "@/lib/constansts";
import {LoginRequest} from "@/src/modules/auth/types";
import {errorHandler} from "@/src/modules/core/lib";
import {useToast} from "@/src/modules/core/hooks";
import {clearRequiresProfileCompletionPending} from "@/src/modules/resident-claim/lib/claim-profile-pending";

import {parseLoginErrorMessage} from "../lib/parse-login-error";
import {clearSessionEndedLoginSearch} from "../lib/session-ended-copy";
import {authService} from "../services";

export default function useLogin() {
  const toast = useToast();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return useMutation({
    mutationFn: (data: LoginRequest) => authService.login(data),
    retry: false,
    onMutate: () => {
      clearSessionEndedLoginSearch(navigate, searchParams);
    },
    onSuccess: () => {
      clearRequiresProfileCompletionPending();
    },
    onError: (error) => {
      clearSessionEndedLoginSearch(navigate);
      const message = parseLoginErrorMessage(error);
      if (message) {
        toast.error(message, TOAST_CONFIG);
        return;
      }
      errorHandler(error);
    },
  });
}
